import { Controller } from "@hotwired/stimulus"

// One Enter contract for every composer (the Jane bar on home, the sidebar
// compose panel, the ask bar on a thread, and every human-to-human thread that
// renders shared/_message_composer):
//
//   Enter                 send
//   Shift/Alt + Enter     newline (a textarea; a no-op in the single-line bar)
//   Cmd/Ctrl + Enter      send, wherever your hands already are
//
// We submit by hand rather than leaning on the browser's implicit submission,
// which the unified composer had quietly killed: the plus-menu variant carries
// a `.composer-send` submit button that stays disabled while the message is
// going to Jane, and a form whose FIRST submit button in tree order is disabled
// submits on Enter for nobody — the arrow button that assistant-compose flips to
// type=submit sits after it and never gets to be the default. On the message
// side there was never an Enter at all: those fields are textareas, so Enter
// only ever opened a new line.
export default class extends Controller {
    // Bound on the field itself (keydown->composer-submit#onKeydown) so the
    // composer's other inputs — the recipient search box lives inside the same
    // form — keep their own Enter.
    onKeydown(event) {
        if (event.key !== "Enter") return
        // Mid-IME composition Enter commits the candidate; it is not a send.
        if (event.isComposing || event.keyCode === 229) return

        const modified = event.metaKey || event.ctrlKey
        if (!modified && (event.shiftKey || event.altKey)) return

        event.preventDefault()
        const field = event.currentTarget
        if (field.disabled) return
        // A staged Jane attachment (assistant_compose_controller's chip row)
        // makes the message sendable even with an empty field — checked
        // generically here, via the chip row's own visibility, so this
        // controller stays composer-agnostic.
        const hasAttachments = !!this.element.querySelector(".composer-attachments:not([hidden])")
        if (!field.value.trim() && !hasAttachments) return

        if (this.element.requestSubmit) this.element.requestSubmit()
        else this.element.submit()
    }
}
